import { render, staticRenderFns } from "./detection-new.vue?vue&type=template&id=6733eb42&"
import script from "./detection-new.vue?vue&type=script&lang=js&"
export * from "./detection-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports